import React from 'react';
import { Link } from 'react-router-dom';
import './Unsubscribe.css';

function UnsubscribeSuccess() {
  return (
    <div className="unsubscribe-container">
      <div className="unsubscribe-card success-card">
        <div className="success-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="64"
            height="64"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
            <polyline points="22 4 12 14.01 9 11.01" />
          </svg>
        </div>
        <h1>Successfully Unsubscribed</h1>
        <p className="success-message">
          You have been unsubscribed from our marketing emails. You will no longer
          receive promotional content from us.
        </p>
        <p className="success-note">
          Note: You may still receive important account-related notifications.
        </p>
        <Link to="/" className="back-home-link">
          Return to Home
        </Link>
      </div>
    </div>
  );
}

export default UnsubscribeSuccess;